import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
export const autoScrollLogger = new ConsoleLogger("autoscroll", LogLevels.error);
//# sourceMappingURL=logger.js.map